import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {printLocationLabels} from '../../common/util/print';

export const createWarehouseLocation = (data) => apiActionCreator({
  'endpoint': '/warehouses/locations',
  'authenticated': true,
  'types': [
    ActionTypes.CREATING_WAREHOUSE_LOCATION,
    ActionTypes.CREATED_WAREHOUSE_LOCATION,
    [
      ActionTypes.CREATED_WAREHOUSE_LOCATION_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
  'contentType': 'application/json',
  'data': data,
});

export const addWarehouseLocation = () => ({
  'type': ActionTypes.ADD_WAREHOUSE_LOCATION,
});

export const removeWarehouseLocation = (index) => ({
  'type': ActionTypes.REMOVE_WAREHOUSE_LOCATION,
  'payload': index,
});

export const changeSelectedLocationValue = (index, field, value) => ({
  'type': ActionTypes.CHANGE_SELECTED_LOCATION_VALUE,
  'payload': {index, field, value},
});

export const changeSelectedLocationWarehouses = (index, warehouse) => ({
  'type': ActionTypes.CHANGE_SELECTED_LOCATION_WAREHOUSES,
  'payload': {index, warehouse},
});

export const changeLocationsFileLoadingStatus = (status) => ({
  'type': ActionTypes.CHANGE_LOCATION_FILE_LOADING_STATUS,
  'payload': status,
});

export const loadLocationsFile = (data) => ({
  'type': ActionTypes.LOAD_WAREHOUSE_LOCATIONS_FILE,
  'payload': data,
});

export const printCreatedLocations = (locations) => {
  printLocationLabels(locations);
  return {'type': ActionTypes.CLEAR_LOCATIONS_TO_PRINT};
};

export const clearLocationsToPrint = () => ({
  'type': ActionTypes.CLEAR_LOCATIONS_TO_PRINT,
});

export const clearLocations = () => ({
  'type': ActionTypes.CLEAR_LOCATIONS,
});
